<div class="container-fluid admin-form-page">
  <div class="row section1  align-items-center">
    <div class="col">
      <div class="home-details">
        <h5 class="home-title">Create New Survey</h5>
        <p class="home-subtitle">Add new fun-words & quotes</p>
      </div>
    </div>
    <div class="col-auto">
      <div class="dashboard-btn dashboard-manage admin-page-actions ">
        <div><a routerLink="/surveys">
          <button type="button" class="btn btn-primary btn-dashboard">Back</button>
        </a>
      </div>
    </div>
  </div>
  <div class="col-auto pl-0">
    <button class="btn btn-primary btn-dashboard" (click)="createSurvey()" type="button">Add Survey</button>
  </div>
</div>
<div class="section1">
  <div class="applicants-details details1 admin-form-card p-0">
    <div class="admin-form">
      <div class="col-12 job-form">
        <div class="admin-form">
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="surveyQuestion">Question*</label>
                <input name="surveyQuestion" id="surveyQuestion"
                  (ngModelChange)="handleQuestionChange($event)"
                  [(ngModel)]="survey.questions[0].question"
                  class="form-control"/>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <div class="d-flex align-items-center mb-2">
                  <label class="mb-0" for="surveyQuestion">Result suffix</label>
                  <p class="mb-0 ml-2" containerClass="tooltip-light" [tooltip]="popTemplate">
                    <svg width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="12" cy="12" r="10" stroke="#1C274C" stroke-width="1.5"></circle> <path d="M12 17V11" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"></path> <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)" fill="#1C274C"></circle> </g></svg></p>
                    <ng-template #popTemplate>
                      <div class="bg-white" [innerHtml]="html"></div>
                    </ng-template>
                  </div>
                  <input name="surveyResultSuffix" id="resultSuffix" [(ngModel)]="survey.questions[0].result_suffix"
                    class="form-control"/>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <form class="admin-form" (ngSubmit)="addOption()" ngNativeValidate>
                    <div class="col-12 mb-3 px-0 mx-0">
                      <div class="row">
                        <div class="col">
                          <label for="option">Options*</label>
                          <input class="form-control mr-0 pr-0" id="option" type="text" [(ngModel)]="option"
                            name="option" required
                            placeholder="Enter option here..."/>
                        </div>
                        <div class="user-form  col-auto pr-0">
                          <label for="option">Icon</label>
                          <div class="form-group d-flex flex-column mb-0">
                            @if (image) {
                              <div class="position-relative survey-image-container">
                                <img
                                  class="rounded-circle"
                                  style="object-fit: cover" width="45" height="45"
                                  src="{{image}}" alt="">
                                @if (image && !uploading) {
                                  <i (click)="handleClickUpload()"
                                  class="las font-size-16 la-pencil-alt img-icon "></i>
                                }
                                @if (uploading) {
                                  <div class="img-icon-loader">
                                    <img src="assets/images/loading.gif" width="20" alt="">
                                  </div>
                                }
                              </div>
                            }
                            @if (!image) {
                              <div class="position-relative survey-image-container">
                                <img class="rounded-circle"
                                  style="object-fit: cover" width="45"
                                  height="45"
                                  src="assets/images/placeholder.png" alt="">
                                  @if (!image && !uploading) {
                                    <i (click)="handleClickUpload()"
                                    class="las font-size-10 la-plus-circle img-icon "></i>
                                  }
                                  @if (uploading) {
                                    <div class="img-icon-loader">
                                      <img src="assets/images/loading.gif" width="20" alt="">
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                            <input id="option_icon" name="file-upload-field" type="file"
                              accept=".png, .jpg, .jpeg, .webp"
                              class="form-control d-none"
                              (change)="fileChangeEvent($event, imageCropperModal)" required>
                          </div>
                          <div class="col-auto d-flex flex-column">
                            <label class="hide mb-3">Icon</label>
                            <button [disabled]="uploading" class="btn btn-secondary ml-2 mr-0">Add</button>
                          </div>

                        </div>
                      </div>
                    </form>
                    <mat-chip-set>
                      @for (o of survey.questions[0].options; track o; let oi = $index) {
                        <mat-chip class="chip-md" selected>
                          <div class="d-flex align-items-center justify-content-between w-100">
                            <div class="d-flex align-items-center gap-2 ">
                              @if (!!o.image) {
                                <img
                                  class="rounded-circle mr-3"
                                  style="object-fit: cover" width="30" height="30"
                                  src="{{o.image}}" alt="">
                              }
                              {{o.option | capitalize}}
                            </div>
                            <mat-icon class="ml-1 size-md" (click)="removeOption(oi)">cancel</mat-icon>
                          </div>
                        </mat-chip>
                      }
                    </mat-chip-set>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <ng-template #imageCropperModal>
    <div class="modal-header">
      <h5 class="modal-title">Profile image</h5>
      <button type="button" class="close " data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true" class="">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <image-cropper
        (imageCropped)="imageCropped($event)"
        (loadImageFailed)="loadImageFailed()"
        [aspectRatio]=aspectRatio
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true"
        format="png">
      </image-cropper>
    </div>
    <div class="modal-footer justify-content-end">
      <button type="button" class="btn btn-default mr-2" data-dismiss="modal" (click)="modalRef.hide()">Close</button>
      <button (click)="uploadImage(); modalRef.hide()" class="btn btn-primary btn-dashboard" type="button">Crop
      </button>
    </div>
  </ng-template>
